module.exports = __webpack_public_path__ + "img/ar.fcd0f8f5.svg";